import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RequestAccessModal } from './RequestAccessModal';

export function DemoNavbar() {
  const navigate = useNavigate();
  const [showRequestAccessModal, setShowRequestAccessModal] = useState(false);

  return (
    <div className="landing-header">
      <div className="landing-container">
        <div className="landing-logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          <img 
            src="/logo-gold-small.png" 
            alt="recberry" 
            className="landing-logo-image"
          />
        </div>
        
        <div className="landing-nav">
          {/* Desktop layout */}
          <div className="demo-nav-desktop" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem'
          }}>
            <button 
              onClick={() => navigate('/')}
              className="btn btn-secondary"
            >
              Back to Home
            </button>
            <button 
              onClick={() => setShowRequestAccessModal(true)}
              className="btn btn-primary"
            >
              Start Free Course
            </button>
          </div>

          {/* Mobile layout */}
          <div className="demo-nav-mobile" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            width: '100%',
            justifyContent: 'flex-end'
          }}>
            <button 
              onClick={() => setShowRequestAccessModal(true)}
              className="btn btn-primary"
              style={{
                padding: '0.5rem 1rem',
                fontSize: '0.8rem',
                whiteSpace: 'nowrap'
              }}
            >
              START FREE COURSE
            </button>
          </div>
        </div>
      </div>
      
      {/* Request Access Modal */}
      <RequestAccessModal
        isOpen={showRequestAccessModal}
        onClose={() => setShowRequestAccessModal(false)}
        onSuccess={() => {
          setShowRequestAccessModal(false);
          // User will receive email with credentials
        }}
        title="Start Free Course"
      />
    </div>
  );
}
